import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { Callout, FontWeights, Text, TooltipHost, mergeStyleSets } from '@fluentui/react';
import ChartGauge from '../Chart/ChartGauge';
import { useState } from 'react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

function OCR_CHART_LIST(props) {
  	const { t } = useTranslation();
  	const dispatch = useDispatch();

  	const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

    const { 
		inputParam_ReportMode = false,
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_ReportHeaderMode = false,
		inputParam_BoardStructure = null,
        inputParam_Container = null,
		inputParam_ComponentConfig = null
    } = props;

	const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
	const [executedLoad, setExecutedLoad] = useState(false);
	const [inputParam_SeriesConfig] = useState(JSON.parse(inputParam_ComponentConfig.htmlStyle))
	

	const [selectedGaugeDataPointIndex, setSelectedGaugeDataPointIndex] = useState(
		inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
			(inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.length -1 : 0) : 0))
		: 0): 0);

	const [lastGaugeDataPointIndex, setLastGaugeDataPointIndex] = useState(
		inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
			(inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.length -1 : 0) : 0))
		: 0): 0);

	const _base = inputParam_SeriesConfig.map(serie =>
		({
			name: !isNullUndefinedOrEmpty(serie.acronim) ? serie.acronim : ((serie.useDataserieName && inputParam_ComponentContent.items.length > 0) ? (inputParam_ComponentContent.items[0].l_dataserie.find(dataserie => (!isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlId) && inputParam_ComponentConfig.htmlId === "1" ? dataserie.masterKPINemo : dataserie.tag) === serie.serieIdentifier)?.variableName) : ""),
			type: "bar",//serie.serieType,
			data: inputParam_ComponentContent?.items.length > 0 ?
					(!isNullUndefined(inputParam_ComponentContent.items[0].l_vals) ?
						inputParam_ComponentContent.items[0].l_vals.map(item => ({x: item.serieTimeStr, y: item[serie.seriePropertyName]})) :
							(
								inputParam_ComponentContent.items[0].l_dataserie.length > 0 ?
									(!isNullUndefined(inputParam_ComponentContent.items[0].l_dataserie.find(x => (inputParam_ComponentConfig.htmlId === "1" ? x.masterKPINemo : x.tag) === serie.serieIdentifier)) ? inputParam_ComponentContent.items[0].l_dataserie.find(x => (inputParam_ComponentConfig.htmlId === "1" ? x.masterKPINemo : x.tag) === serie.serieIdentifier).l_vals.map(item => ({x: item.serieTimeStr , y: item[serie.seriePropertyName]})) : []) : [])) : []
		})
	);

  	const listSeriesX = inputParam_ComponentContent ? _base : [];

	const listSerieTimeY = Array.from(new Set(listSeriesX.flatMap(s => s.data.map(p => p.x)))).sort();
  
  	const _baseSerieNames = inputParam_SeriesConfig.map(({ serieConfig, formatter }) =>(
		formatter && formatter === true ? {
			min: Math.min(...listSeriesX.flatMap(s => s.data.map(d => d.y)).filter(y => y !== null)),
			max: Math.max(...listSeriesX.flatMap(s => s.data.map(d => d.y)).filter(y => y !== null)),
			...serieConfig,
			formatter: function (val) { return val.toFixed(0); }
		} : {
			min: Math.min(...listSeriesX.flatMap(s => s.data.map(d => d.y)).filter(y => y !== null)),
			max: Math.max(...listSeriesX.flatMap(s => s.data.map(d => d.y)).filter(y => y !== null)),
			...serieConfig
		}
	));

	const getTitleSubTitle = () => {
		let title = '';
		let subtitle = '';

		if (boardVariableDataserieValues !== null && inputParam_ComponentContent !== null) {
			if ( (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.length > 0) && inputParam_ComponentContent.items[0].l_dataserie !== undefined && inputParam_ComponentContent.items[0].l_dataserie.length > 0) {
				const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items[0].l_dataserie[0].dataSerieId));
				title = !isNullUndefinedOrEmpty(item) ? item.variableName : "";
				subtitle = !isNullUndefinedOrEmpty(item) ? item.um : "";
			}
			if (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.l_dataserie !== undefined && inputParam_ComponentContent.items.l_dataserie.length > 0) {
				const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items.l_dataserie[0].dataSerieId))
				title = !isNullUndefinedOrEmpty(item) ? item.variableName : "";
				subtitle = !isNullUndefinedOrEmpty(item) ? item.um : "";
			}
		}

		return { title: title, subtitle: subtitle }
	}

	const objTitles = getTitleSubTitle()

	const chartRef = useRef(null);

	useEffect(() => {
		try {
			if (inputParam_ComponentContent && executedLoad === false) {
				setTimeout(() => {
					if (chartRef.current !== null) {
						const chart = chartRef.current.chart;

						inputParam_SeriesConfig.map(serie => 
							{
								if (serie.toggled && !serie.useDataserieName) {
									chart.toggleSeries(serie.acronim)
								}
							}
						)

						setExecutedLoad(true)
					}
				}, "500");
			}
		} catch (error) {
			
		}
    }, [inputParam_ComponentContent]);

	const styles = mergeStyleSets({
		callout: {
			width: 320,
			maxWidth: '90%',
			padding: '20px 24px',
		},
		title: {
		  	marginBottom: 12,
		  	fontWeight: FontWeights.semilight,
		}
	});

	const checkDataPointIndex = () => {
		const currentDataPointIndexLength = (inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
				(inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.length -1 : 0) : 0))
			: 0): 0)

		if (currentDataPointIndexLength !== lastGaugeDataPointIndex) {
			setSelectedGaugeDataPointIndex(currentDataPointIndexLength)
			setLastGaugeDataPointIndex(currentDataPointIndexLength)
		}
		
		return currentDataPointIndexLength
	}

	return  <Card className='board-element-form h-100'>
				{
					!inputParam_HideHeader && inputParam_ComponentContent &&
					<>
						{
							inputParam_ReportHeaderMode ?
							<Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
								<TooltipHost content={inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}>
									<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
										{
											!isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlTitle) &&
											<b>{inputParam_ComponentConfig.htmlTitle.indexOf('data-lang-') ? t(inputParam_ComponentConfig.htmlTitle) :inputParam_ComponentConfig.htmlTitle}</b>
										}
										{
											isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlTitle) &&
											<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? (inputParam_ComponentContent.boardComponentTitle.indexOf('data-lang-') ? t(inputParam_ComponentContent.boardComponentTitle) : inputParam_ComponentContent.boardComponentTitle) : t('data-lang-lbl-chart')}</b>
										}
									</div>
								</TooltipHost>
							</Card.Body> :
							<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
										{
											!isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlTitle) &&
											<b>{inputParam_ComponentConfig.htmlTitle.indexOf('data-lang-') ? t(inputParam_ComponentConfig.htmlTitle) :inputParam_ComponentConfig.htmlTitle}</b>
										}
										{
											isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlTitle) &&
											<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? (inputParam_ComponentContent.boardComponentTitle.indexOf('data-lang-') ? t(inputParam_ComponentContent.boardComponentTitle) : inputParam_ComponentContent.boardComponentTitle) : t('data-lang-lbl-chart')}</b>
										}
									<div className='toolbar d-flex'>
										<HEADER_TOOLBAR
											inputParam_BoardStructure={inputParam_BoardStructure}
											inputParam_Container={inputParam_Container}
										/>
									</div>
								</Card.Title>
							</Card.Header>
						}
					</>
				}
				<Card.Body className='h-100 px-2 pt-2'>
				{
					inputParam_SeriesConfig && inputParam_ComponentContent && inputParam_ComponentContent.items ?
						<div className='px-3 h-100 d-flex'>
							<Col>
								<ReactApexChart
									ref={chartRef}
									type="line"
									series={ listSeriesX }
									options={{
										subtitle: {
											text: inputParam_ReportMode ? "" : objTitles.subtitle,
											align: 'center',
										},
										colors: ['#1F7BE8', '#000099', '#FF8000'],
										chart: {
											height: 350,
											type: 'line',
											stacked: false,
											events: {
												dataPointSelection: (event, chartContext, config) => { 
													setTimeout(() => {
														setSelectedGaugeDataPointIndex(config.dataPointIndex);
													}, 10);
												}
											},
											toolbar: {
												tools: {
													customIcons: [{
														icon: `<i class="ms-Icon ms-Icon--FileComment" aria-hidden="true"></i>`,
														index: -1,
														title: t('data-lang-lbl-charttooltiplegend'),
														class: 'custom-legeng-chart',
														click: toggleIsCalloutVisible
													}]
												}
											}
										},
										dataLabels: {
											enabled: true,
											formatter: (val) => {
												if (val === null || val === undefined || val === "") return ""; // sin dato
												const n = Number(val);
												if (!Number.isFinite(n)) return ""; // sin dato
												return n === 0 ? "0" : "";          // SOLO mostrar cuando es 0
											},
										},
										stroke: {
											width: [2, 2, 2],
											dashArray: [0, 0, 5]
										},
										xaxis: {
											categories: listSerieTimeY,
										},
										yaxis: _baseSerieNames,
										tooltip: {
											fixed: {
											enabled: true,
											position: 'topLeft',
											offsetY: 30,
											offsetX: 60
											},
										},
										legend: {
											horizontalAlign: 'center',
											offsetX: 40
										},
										responsive: [{
											breakpoint: undefined,
											options: {},
										}]
									}}
									height={"100%"}
								/>
								{isCalloutVisible &&
									<Callout
										role="dialog"
										gapSpace={0}
										target={`.custom-legeng-chart`}
										onDismiss={toggleIsCalloutVisible}
										setInitialFocus
										className={styles.callout}
									>
										<Text as="h1" block variant="xLarge"> { t('data-lang-lbl-chartlegend') } </Text>
										<Text className='pb-2' block variant="small">
											{
												inputParam_SeriesConfig.map(serie =>
													<Row>
														<Col className='col-auto'>
														{
															!serie.useDataserieName &&
															<><b>{`${serie.acronim}:`}</b> {`${serie.text}`}</>
														}
														{
															serie.useDataserieName &&
															<b>{`${inputParam_ComponentContent.items[0].l_dataserie.find(x => (!isNullUndefinedOrEmpty(x.masterKPINemo) ? x.masterKPINemo : x.tag) === serie.serieIdentifier)?.variableName}:`}</b>
														}
														</Col>
													</Row>
												)
											}
										</Text>
									</Callout>
								}
							</Col>
						</div>
						: <NoDataLayer display={ true } />
					}
				</Card.Body>
			</Card>
}

OCR_CHART_LIST.propTypes = {
	inputParam_HideHeader: PropTypes.bool,
  	inputParam_ReportMode: PropTypes.bool,
	inputParam_SeriesConfig: PropTypes.array,
	inputParam_ComponentContent: PropTypes.object,
	inputParam_ReportHeaderMode: PropTypes.bool,
	inputParam_BoardStructure: PropTypes.object,
	inputParam_Container: PropTypes.object
};

export default OCR_CHART_LIST;